module.exports = __webpack_public_path__ + "img/ttmesaj-logo.a3f96afb.svg";